class EbAnnouncementRotator extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll("[data-announcement-slide]"));
    this.currentIndex = Math.max(
      0,
      this.slides.findIndex((slide) => slide.classList.contains("is-active"))
    );
    this.rotationInterval = Number.parseInt(this.dataset.rotationInterval, 10) || 5000;
    this.slides.forEach((slide, index) => {
      slide.inert = index !== this.currentIndex;
    });

    if (this.slides.length <= 1) return;

    this.startRotation = this.startRotation.bind(this);
    this.stopRotation = this.stopRotation.bind(this);
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);

    this.addEventListener("mouseenter", this.stopRotation);
    this.addEventListener("mouseleave", this.startRotation);
    this.addEventListener("focusin", this.stopRotation);
    this.addEventListener("focusout", this.startRotation);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);

    this.startRotation();
  }

  disconnectedCallback() {
    this.stopRotation();
    this.removeEventListener("mouseenter", this.stopRotation);
    this.removeEventListener("mouseleave", this.startRotation);
    this.removeEventListener("focusin", this.stopRotation);
    this.removeEventListener("focusout", this.startRotation);
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  }

  handleVisibilityChange() {
    if (document.hidden) {
      this.stopRotation();
    } else {
      this.startRotation();
    }
  }

  startRotation() {
    if (this.timer || document.hidden) return;
    this.timer = window.setInterval(() => this.showNextSlide(), this.rotationInterval);
  }

  stopRotation() {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = null;
  }

  showNextSlide() {
    const nextIndex = (this.currentIndex + 1) % this.slides.length;

    this.slides[this.currentIndex].classList.remove("is-active");
    this.slides[this.currentIndex].setAttribute("aria-hidden", "true");
    this.slides[this.currentIndex].inert = true;
    this.slides[nextIndex].classList.add("is-active");
    this.slides[nextIndex].setAttribute("aria-hidden", "false");
    this.slides[nextIndex].inert = false;
    this.currentIndex = nextIndex;
  }
}

if (!customElements.get("eb-announcement-rotator")) {
  customElements.define("eb-announcement-rotator", EbAnnouncementRotator);
}
